"use client";

import {Button} from "@/components/ui/button";
import {useState} from "react";
import axios from "axios";
import toast from "react-hot-toast";

export default function NewsletterForm(){
    const [email, setEmail] = useState("");

    function subscribeNewsletter(e){
        e.preventDefault();
        axios.post("/api/newsletter", {email})
            .then(res => toast.success("Félicitation vous êtes maintenant abonné"))
            .catch(err => toast.error("Une erreur s'est produite"))
            .finally(() => setEmail(""))
    }

    return (
        <form className={"relative"} onSubmit={subscribeNewsletter}>
            <input type={"email"}
                   className={"border-none rounded-lg placeholder:italic placeholder:font-thin w-full shadow-2xl"}
                   placeholder={"Votre adresse mail..."} value={email} onChange={e => setEmail(e.target.value)}/>
            <div className={"absolute top-0 right-0 h-full"}>
                <Button className={"h-full"}>Valider</Button>
            </div>
        </form>
    )
}